import { combineReducers } from 'redux'
import {
  PORT_PAGE_ERROR, PORT_PAGE_LOADING, PORT_LIST_SUCCESS,
  PORT_VIEW_SUCCESS, PORT_PAGE_SUCCESS, PORT_VIEW_ERROR,
  PORT_ADD_ERROR, PORT_ADD_LOADING, PORT_ADD_SUCCESS,
  PORT_VIEW_LOADING, PORT_DELETE_ERROR, PORT_DELETE_LOADING,
  PORT_DELETE_SUCCESS, PORT_UPDATE_SUCCESS, PORT_UPDATE_ERROR, PORT_UPDATE_LOADING, PORT_LIST_ERROR, PORT_LIST_LOADING
} from './constant'

const portPageError = (state = false, action) => {
  switch (action.type) {
    case PORT_PAGE_ERROR:
      return action.portPageError
    default:
      return state
  }
}

const portPageLoading = (state = false, action) => {
  switch (action.type) {
    case PORT_PAGE_LOADING:
      return action.portPageLoading
    default:
      return state
  }
}

const portPageSuccess = (state = false, action) => {
  switch (action.type) {
    case PORT_PAGE_SUCCESS:
      return action.portPageSuccess
    default:
      return state
  }
}

const ports = (state = [], action) => {
  switch (action.type) {
    case PORT_PAGE_SUCCESS:
      return action.port
    case PORT_LIST_SUCCESS:
      return action.port
    default:
      return state
  }
}

const port = (state = [], action) => {
  switch (action.type) {
    case PORT_VIEW_SUCCESS:
      return action.port
    default:
      return state
  }
}

const portAddError = (state = { status: false, message: '' }, action) => {
  switch (action.type) {
    case PORT_ADD_ERROR:
      return {
        ...state,
        status: action.portAddError,
        message: action.message
      }
    default:
      return state
  }
}

const portAddLoading = (state = false, action) => {
  switch (action.type) {
    case PORT_ADD_LOADING:
      return action.portAddLoading
    default:
      return state
  }
}

const portAddSuccess = (state = false, action) => {
  switch (action.type) {
    case PORT_ADD_SUCCESS:
      return action.portAddSuccess
    default:
      return state
  }
}

const portViewError = (state = false, action) => {
  switch (action.type) {
    case PORT_VIEW_ERROR:
      return action.portViewError
    default:
      return state
  }
}

const portViewLoading = (state = false, action) => {
  switch (action.type) {
    case PORT_VIEW_LOADING:
      return action.portViewLoading
    default:
      return state
  }
}

const portViewSuccess = (state = false, action) => {
  switch (action.type) {
    case PORT_VIEW_SUCCESS:
      return action.portViewSuccess
    default:
      return state
  }
}

const portDeleteError = (state = false, action) => {
  switch (action.type) {
    case PORT_DELETE_ERROR:
      return action.portDeleteError
    default:
      return state
  }
}

const portDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case PORT_DELETE_LOADING:
      return action.portDeleteLoading
    default:
      return state
  }
}

const portDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case PORT_DELETE_SUCCESS:
      return action.portDeleteSuccess
    default:
      return state
  }
}

const portUpdateError = (state = { status: false, message: '' }, action) => {
  switch (action.type) {
    case PORT_UPDATE_ERROR:
      return {
        ...state,
        status: action.portUpdateError,
        message: action.message
      }
    default:
      return state
  }
}

const portUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case PORT_UPDATE_LOADING:
      return action.portUpdateLoading
    default:
      return state
  }
}

const portUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case PORT_UPDATE_SUCCESS:
      return action.portUpdateSuccess
    default:
      return state
  }
}

const portListError = (state = false, action) => {
  switch (action.type) {
    case PORT_LIST_ERROR:
      return action.portListError
    default:
      return state
  }
}

const portListLoading = (state = false, action) => {
  switch (action.type) {
    case PORT_LIST_LOADING:
      return action.portListLoading
    default:
      return state
  }
}

const portListSuccess = (state = false, action) => {
  switch (action.type) {
    case PORT_LIST_SUCCESS:
      return action.portListSuccess
    default:
      return state
  }
}

const portReducer = combineReducers({
  portPageError,
  portPageLoading,
  portPageSuccess,

  ports,
  port,

  portAddError,
  portAddLoading,
  portAddSuccess,

  portViewError,
  portViewLoading,
  portViewSuccess,

  portDeleteError,
  portDeleteLoading,
  portDeleteSuccess,

  portUpdateError,
  portUpdateLoading,
  portUpdateSuccess,

  portListError,
  portListLoading,
  portListSuccess,
})

export default portReducer
